import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { mainTaskStayByCreateRoleTime } from "../../../api/task";
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import TaskOptions from "../../../components/serverList/taskOptions.vue";
export default {
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions,
    TaskOptions: TaskOptions
  },
  name: "mainTaskStayByCreateRoleTime",
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    return {
      searchInfo: {
        task_id: "",
        server_id: []
      },
      timedata: [this.$moment().format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableData: [],
      tableDataCount: {},
      tableColumn: [{
        field: "task_id",
        title: "任务ID",
        sortable: true
      }, {
        field: "task_name",
        title: "任务名称",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "accept_num",
        title: "任务接收人数",
        sortable: true
      }, {
        field: "complete_num",
        title: "任务完成人数",
        sortable: true
      }, {
        field: "complete_time_use",
        title: "任务完成所需时间(单位:秒)",
        sortable: true
      }, {
        field: "avg_complete",
        title: "平均停留时间(秒)",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [_this.cal.toDecimal2(row.complete_num > 0 ? row.complete_time_use / row.complete_num : 0)])];
          }
        }
      }, {
        field: "stop",
        title: "停留率",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [_this.cal.toDecimal2(row.accept_num > 0 ? (row.accept_num - row.complete_num) / row.accept_num * 100 : 0), "%"])];
          }
        }
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.timedata[0];
              _this2.searchInfo.edate = _this2.timedata[1];
              _context.next = 4;
              return mainTaskStayByCreateRoleTime(_this2.searchInfo);
            case 4:
              res = _context.sent;
              if (!res.data || res.data.length == 0) {
                _this2.tableData = [];
                _this2.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this2.tableData = res.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    toDecimal2: function toDecimal2(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    }
  }
};